import { Dispatch, SetStateAction } from 'react';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { ITExplanationModalStep } from '../hooks';
import { useConfirmation } from './hooks';
import { InputMeetingDateTimeProps } from '../ItDisclosureApplicationDateSelection/hooks';
import { SymbolPageStep } from '../../../hooks';
import { formatPrice } from 'views/utils/converter';

type ConfirmationProps = {
  amount: number;
  setModalStep: Dispatch<SetStateAction<ITExplanationModalStep>>;
  onClosed: (nextSymbolPageStep: SymbolPageStep, meetingDateTime?: Partial<InputMeetingDateTimeProps>) => void;
};

export const Confirmation = ({ amount, onClosed, setModalStep }: ConfirmationProps) => {
  const { confirmationProps } = useConfirmation({ onClosed, setModalStep });
  return (
    <div className="itExplanation-modal_confirmation">
      <div className="itExplanation-modal_confirmation_label">{`お申込み個数は${formatPrice(amount)}個です。
個数にお間違えのないようお手続きを進めてください。`}</div>
      <div className="itExplanation-modal_confirmation_label">{`適合性チェックがお済でないかたは、適合性チェックを行っていただいてから「申込内容の確認」にお進みいただきます。`}</div>
      <div className="itExplanation-modal_button">
        <Button
          type={ButtonType.Submit}
          label={'電子交付・IT重説の申込みに進む'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          onClick={confirmationProps.onClick}
        />
      </div>
    </div>
  );
};
